import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//   isAvaliable: false,
// };

const loaderControllerSlice = createSlice({
  name: 'loaderController',
    initialState: {
        isAvailable: false,
    },
    reducers: { 
        setLoaderAvailable: (state, action) => {
            state.isAvailable = action.payload;
        },
        resetLoaderAvailable: (state) => {
            state.isAvailable = false;
        },
    },

});
export const { setLoaderAvailable, resetLoaderAvailable } = loaderControllerSlice.actions;
export default loaderControllerSlice.reducer;
